import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { GlossariesApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { glossaryQueryKeys } from './queryKeys'

type Options = Omit<UseMutationOptions<void, unknown, File>, 'mutationFn'>

export const useUploadGlossaryCsv = (options?: Options) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async (file: File) => {
      await baseClient
        .getApi(GlossariesApi)
        .postGlossaryJobs({ file })
        .catch(handleHTTPError)
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: glossaryQueryKeys.glossaryJobs.all,
      })
      options?.onSuccess?.(...args)
    },
    onError: (error, ...rest) => {
      options?.onError?.(error, ...rest)
    },
  })
}
